import { DeliveryConfiguration } from '../@types/model/deliveryConfiguration';
import { atom } from 'recoil';
import axios from '../utils/axios';
// eslint-disable-next-line import/extensions
import localStorageEffect from './localStorageEffect.js';
import { DeliveryRequest, DeliveryRequestItem } from '../@types/model/deliveryRequest';

const deliveryRequestState = atom<DeliveryRequest[]>({
  key: 'deliveryRequest',
  default: [],
  effects: [localStorageEffect('deliveryRequests')]
});

const getDeliveryRequests = async (guid: string = '') => {
  let url = '/api/v2/delivery-request?offset=0&size=100';
  if (guid !== '') url = '/delivery-request/' + guid;
  const result = await axios.get(url);
  let deliveryRequests: DeliveryRequest[] = result.data.data.map((dat: any) => {
    return dat.attributes as DeliveryRequest;
  });
  const deliveryRequestDeliveryConfigurations: any = result.data.included.filter((dat: any) => {
    if (dat.type === 'App\\Order\\Domain\\Model\\DeliveryConfiguration') return true;
    return false;
  });
  const deliveryRequestDevice: any = result.data.included.filter((dat: any) => {
    if (dat.type === 'App\\Domain\\Model\\Device\\Device') return true;
    return false;
  });
  const deliveryRequestUser: any = result.data.included.filter((dat: any) => {
    if (dat.type === 'App\\Domain\\Model\\User\\User') return true;
    return false;
  });
  deliveryRequests = deliveryRequests.map((dr: DeliveryRequest) => {
    const drus: any[] = deliveryRequestUser.filter((sru: any) => {
      if (sru?.guid === dr.user) return true;
      return false;
    });
    let user_data = null;
    if (drus.length > 0) {
      user_data = {
        guid: drus[0]?.guid,
        name: drus[0]?.attributes?.name,
        email: drus[0]?.attributes?.email
      };
    }
    const drdcs: any[] = deliveryRequestDeliveryConfigurations.filter((drdc: any) => {
      if (drdc?.guid === dr.delivery_configuration) return true;
      return false;
    });
    let delivery_configuration_data = null;
    if (drdcs.length > 0) {
      delivery_configuration_data = drdcs[0].attributes as DeliveryConfiguration;
    }
    let items: DeliveryRequestItem[] = [];
    if (dr.items) {
      let newItems: DeliveryRequestItem[] = [];
      if (dr) {
        Object.keys(dr.items).forEach((key: any) => {
          if (dr !== null) {
            if (dr.items !== null) {
              if (dr.items[key] !== null) {
                newItems.push(dr.items[key] as DeliveryRequestItem);
              }
            }
          }
        });
      }
      items = newItems.map((item: any) => {
        const drds = deliveryRequestDevice.filter((drd: any) => {
          if (drd?.guid === item.attributes.device) return true;
          return false;
        });
        let device_data = null;
        if (drds.length > 0) {
          device_data = drds[0];
        }
        return {
          ...item,
          device: item?.attributes?.device,
          guid: item?.attributes?.guid,
          quantity: item?.attributes?.quantity,
          device_data: device_data,
          productType: item?.attributes?.product_type_guid,
          productScheduleItem: item?.attributes?.product_schedule_item_guid
        } as DeliveryRequestItem;
      });
    }
    return {
      ...dr,
      user_data: user_data,
      delivery_configuration_data: delivery_configuration_data,
      items: items
    };
  });
  return {
    deliveryRequests: deliveryRequests,
    deliveryRequestDeliveryConfigurations: deliveryRequestDeliveryConfigurations,
    deliveryRequestDevice: deliveryRequestDevice
  };
};

export { deliveryRequestState, getDeliveryRequests };
